import { graphql } from "react-relay";
import { CalendarProfile } from "./CalendarProfile";

export const calendarProfileQuery = graphql`
  query CalendarProfileRendererQuery(
    $orgRelayId: ID!
    $calendarId: String!
    $calendarIds: [String]!
    $timeZone: String!
    $rangeMin: DayTimeSlotInput!
    $rangeMax: DayTimeSlotInput!
    $showWeekInReview: Boolean!
    $week: String!
  ) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        ...CalendarProfile_org
          @arguments(
            calendarId: $calendarId
            calendarIds: $calendarIds
            timeZone: $timeZone
            rangeMin: $rangeMin
            rangeMax: $rangeMax
            showWeekInReview: $showWeekInReview
            week: $week
          )
      }
    }
  }
`;
